import { gql } from '@apollo/client';

export const REDEEM_MG_UNLOCK_CODE = gql`
  mutation redeemUnlockCode(
    $benefitUid: String!
    $benefitTargetUid: String!
    $benefitTargetType: BenefitType!
    $targetType: String!
    $input: RedeemUnlockCodeInput!
  ) {
    redeemUnlockCode(
      benefitUid: $benefitUid
      benefitTargetUid: $benefitTargetUid
      benefitTargetType: $benefitTargetType
      targetType: $targetType
      input: $input
    ) {
      status
      message
      targetId
      targetType
    }
  }
`;
